import { useState, useEffect } from "react";
import Globalcataloguelabel from "../../../controls/Globalcataloguelabel";
import DetailTable from "../../../controls/DetailTable";
import DetailRow from "../../../controls/DetailRow";

import { useSelector } from "react-redux";
import { selectProductModule } from "../../../../redux/slices/customFieldSlice";
import { selectRegistration } from "../../../../redux/slices/userSlice";
import CustomTable from "../../../controls/CustomTable";
const ProductOverview = ({ productData,isSmartStore }) => {
  const [imgArray, setImgArray] = useState([]);
  const registrationData = useSelector(selectRegistration);
  console.log(registrationData, "select registration");


  const productCustomFields = useSelector(selectProductModule);




  // Get the first product field (if available)
  const customFieldData = productCustomFields;
  console.log("customfields", customFieldData);

  useEffect(() => {
    const defaultImage = ["/noimage/noimage.jpeg"];
    setImgArray(productData?.Images?.length ?
      productData.Images.map(img => img.ImagePath) :
      defaultImage
    );
  }, [productData]);
  console.log("productdata",productData);

  return (
    <div className="p-4">
      <div >
        {/* Left Column */}
        <div className="mr-2 ">
          {/* General Details */}
          <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-4">
            <DetailTable title="General Details" mt="mt-[10px]">
               

                <DetailRow label="Name" value={productData.Name}  />
              <DetailRow label="Type" value={productData.ProductType}  />
              <DetailRow label="SKU" value={productData.SKU} />
              <DetailRow label="Barcode" value={productData.BarCode} />
                <DetailRow label="Category" value={productData.Category} />
              <DetailRow label="Sub Category" value={productData.SubCategory} />
              <DetailRow label="Brand" value={productData.Brand} />
            <DetailRow
                label="Short Description"
                value={productData.Description ? { __html: productData.Description } : null}
              />
                <DetailRow
                  label="Long Description"
                  value={productData.LongDescription}
                  type={"html"}
                />
            </DetailTable>
            {/* Right Column - Images */}
            <div className=" ml-2">
              <div className={imgArray.length < 4 ? "flex justify-center gap-5 mt-[20px]" : "grid lg:grid-cols-4 sm:grid-cols-2 gap-5 mt-[20px]"}>
                {imgArray.map((image, index) => (
                  <div key={index} className="relative transition-transform duration-300 ease-in-out hover:scale-110 border border-[#d7d5e2] shadow rounded-lg">
                    <img
                      src={image}
                      alt={`Product ${index + 1}`}
                      className="h-[150px] w-full object-cover rounded-lg"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Price & Taxes */}
          <DetailTable title="Price & Taxes">
            <DetailRow label="Sold at specific stores only" value={productData?.AccessibleToSelectedStores || "No"}  />
            <DetailRow label="Some stores have different pricing" value={productData?.StoreSpecificPricing || "No"} condition={!productData.AccessibleToSelectedStores} />
          </DetailTable>
          {  productData?.StoreSpecificPrices?.length > 0 && (
            <div className="h-auto my-2 w-[600px]">
              <CustomTable
                noShadow={true}
                columns={[
                  { field: "store", headerName: "Store"},
                  { field: "supplyPrice", headerName: "Supply Price", type:"currency"},
                      { field: "marginPercentage", headerName: "Margin Percentage",align: 'right'},
                          { field: "marginAmount", headerName: "Margin Amount", type:"currency" },
                  { field: "MSP", headerName: "MSP", type:"currency" },
                  { field: "retailPrice", headerName: "Retail Price", type:"currency" },
                  { field: "discPercentage", headerName: "Disc %", type:"currency"},
                  { field: "discAmt", headerName: "Disc Amt", type:"currency" },
                  { field: "MRP", headerName: "MRP", type:"currency" },
                ]}
                rows={productData.StoreSpecificPrices.map((row, index) => ({
                  id: index,
                  store: row.Store,
                  marginPercentage:row.MarginPercentage,
                  marginAmount:row.MarginAmount,
                  supplyPrice: row.SupplyPrice,
                  MSP: row.MSP,
                  retailPrice: row.RetailPrice,
                  discPercentage: row.DiscountPercentage,
                  discAmt: row.DiscountAmount,
                  MRP: row.MRP,
                }))}
              />
            </div>
          )}
          
          <DetailTable>
            {(!productData.AccessibleToSelectedStores) && <>

              <DetailRow label="Supply Price" value={productData.SupplyPrice} type={"currency"} dontShowAtRightSide={true}/>
                  <DetailRow label="Margin %" value={productData.MarginPercentage}  dontShowAtRightSide={true} />
                      <DetailRow label="Margin Amount" value={productData.MarginAmount}  type={"currency"} dontShowAtRightSide={true} />
              <DetailRow label="MSP" value={productData.MSP} type={"currency"} dontShowAtRightSide={true}/>
              <DetailRow label="Retail Price" value={productData.RetailPrice}  type={"currency"} dontShowAtRightSide={true} />
              <DetailRow label="Discount %" value={`${productData.DiscountPercentage || 0}%`} dontShowAtRightSide={true} />
              <DetailRow label="Discount Amount" value={productData.DiscountAmount} type={"currency"} dontShowAtRightSide={true}/>
              <DetailRow label="MRP" value={productData.MRP} type={"currency"}  dontShowAtRightSide={true} /></>}
            <DetailRow label="HSN SAC Code" value={productData.HSNSACCode} />
            <DetailRow label="Charge taxes on this product" value={productData.ChargeTaxOnProduct} />
            <DetailRow label="Tax Group" value={productData.TaxGroup} />
            <DetailRow label="Tax based on retail price" value={productData.PriceBasedTax} />
          </DetailTable>
          {( productData?.TaxPriceRange?.length > 1) && (
            <div className="h-auto w-[350px] my-2">
              <CustomTable
                noShadow={true}
                columns={[
                  { field: "TaxGroup", headerName: "Tax", width: "w-[100px]", },
                  { field: "FromPrice", headerName: "From Price", align: "right" },
                  { field: "ToPrice", headerName: "To Price", align: 'right' },

                ]}
                rows={productData.TaxPriceRange.map((row, index) => ({
                  FromPrice: row.FromPrice,
                  ToPrice: row.ToPrice,
                  TaxGroup: row.TaxGroup
                }))}
              />
            </div>
          )}
          <DetailTable>
            <DetailRow
              label="Tax Inclusive (Purchase)"
              value={productData.TaxInclusivePurchase}
              condition={productData.ChargeTaxOnProduct}
            />
            <DetailRow
              label="Tax Inclusive (Sales)"
              value={productData.TaxInclusive}
              condition={productData.ChargeTaxOnProduct}
            />

          </DetailTable>
         {(productData?.ProductTypeID=== 1 || productData?.ProductTypeID=== 2) && <DetailTable title="Inventory">
            <DetailRow
              label="Inventory Type"
              value={productData.InventoryType}
            />
            <DetailRow
              label="Unique Label"
              value={productData?.UniqueLabel}
              condition={productData.InventoryType == "Unique No"}
            />

            <DetailRow
              label="Batch No"
              value={productData?.BatchTrackingBatchNoRequired}
              condition={productData.InventoryType == "Batch No"}
            />
            <DetailRow
              label="MRP"
              value={productData?.BatchTrackingMRPRequired}
              condition={productData.InventoryType == "Batch No"}
            /> <DetailRow
              label="Mfg Date"
              value={productData?.BatchTrackingMfgDateRequired}
              condition={productData.InventoryType == "Batch No"}
            />
            <DetailRow
              label="Exp Date"
              value={productData?.BatchTrackingExpDateRequired}
              condition={productData.InventoryType == "Batch No"}
            />
            <DetailRow
              label="Date Format"
              value={productData?.BatchTrackingDateFormat}
              condition={productData.InventoryType == "Batch No"}
            />


          </DetailTable>}
        {(productData?.ProductTypeID === 1 || productData?.ProductTypeID === 2) && <> {( productData?.Attributes?.length > 0) && (
            <div className="h-auto my-2 w-[350px]">
              <CustomTable
                noShadow={true}
                columns={[
                  { field: "attribute", headerName: "Attribute" },
                  { field: "values", headerName: "Values" },
                ]}
                rows={productData.Attributes.map((attr) => ({
                  attribute: attr.Attribute,
                  values: attr.AttributeValues.map((val) => val.value).join(', '),
                }))}
              />
            </div>

          )}

          {( productData?.Variants?.length > 0) && (
            <div className="h-auto my-2">
              <CustomTable
                noShadow={true}
                columns={[
                  { field: "Name", headerName: "Variant Name" },
                  { field: "SKU", headerName: "SKU" },
                  {field:"SupplyPrice",headerName:"Supply Price",type:"currency"},
                     {field:"MarginPercentage",headerName:"Margin %",type:"percentage"},
                        {field:"MarginAmount",headerName:"Margin Amount",type:"currency"},
                  {field:"MSP",headerName:"MSP",type:"currency"},
  { field: "RetailPrice", headerName: "Retail Price", type:"currency" },
{ field: "DiscountAmount", headerName: "Discount Amount", type:"currency" },
 { field: "DiscountPercentage", headerName: "Discount Percentage", type:"percentage" },
                  { field: "MRP", headerName: "MRP", type:"currency" },
                ]}
      rows={
  productData?.Variants
    ?.filter(variant => variant?.IsDeleted === false)
    ?.sort((a, b) =>
      a.SKU.localeCompare(b.SKU, undefined, { numeric: true, sensitivity: "base" })
    ) || []
}

              />
            </div>

          )}

          {(productData?.StoreSpecificQtys) && (
            <div className={`h-auto my-2 w-[350px]`}>
              <CustomTable
                noShadow={true}
                columns={[
                  { field: "StoreName", headerName: "Store" },
                  { field: "MinQty", headerName: "Min Qty",align:"right" },
                  { field: "MaxQty", headerName: "Max Qty",align:"right" },
                  { field: "ReorderQty", headerName: "Reorder Qty",align:"right" },
                 
                ]}
                rows={productData.StoreSpecificQtys.map((store) => ({
                  StoreCode: store.StoreCode,
                  StoreID: store.StoreID,
                  StoreName: store.StoreName,
                  InStockQty: store.InStockQty || "0",
                  MinQty: store.MinQty || "0",
                  MaxQty: store.MaxQty || "0",
                  ReorderQty: store.ReorderQty || "0",
                }))}
              />

            </div>

          )}
          </>}

          {/* Additional Settings */}
          <DetailTable title="Additional Settings">
            <DetailRow label="Favourite" value={productData.Favourite} />
            <DetailRow label="Allow price edit" value={productData.AllowPriceEdit} />
            <DetailRow label="Discountable" value={productData.AllowDiscount} />
            <DetailRow label="Allow tax change" value={productData.AllowTaxChange} />
            <DetailRow label="Prompt for qty at the time billing" value={productData.QtyPrompt} />
            <DetailRow label="Sequence" value={productData.SequenceNo} />
            <DetailRow label="Packaging Charges" value={productData.PackagingCharges} />
            <DetailRow label="Repack/Produce" value={productData.RepackProduce} />
            <DetailRow label="BOM" value={productData.BOM} />
            <DetailRow label="Manually specify product consumption" value={productData.BOMManual} />
            <DetailRow label="Consumable" value={productData.CanBeUsedAsConsumable} />
            <DetailRow label="Show as additional charges" value={productData.ShowAsAdditionalCharges} />
          </DetailTable>
         
            <DetailTable title="Additional Information">
              <DetailRow label={customFieldData?.CustomField1Name || "Custom Field 1"} value={productData?.CustomField1} />
              <DetailRow label={customFieldData?.CustomField2Name || "Custom Field 2"} value={productData?.CustomField2} />
              <DetailRow label={customFieldData?.CustomField3Name || "Custom Field 3"} value={productData?.CustomField3} />
              <DetailRow label={customFieldData?.CustomField4Name || "Custom Field 4"} value={productData?.CustomField4} />
              <DetailRow label={customFieldData?.CustomField5Name || "Custom Field 5"} value={productData?.CustomField5} />
              <DetailRow label={customFieldData?.CustomField6Name || "Custom Field 6"} value={productData?.CustomField6} />

            </DetailTable>
        </div>


      </div>
    </div>
  );
};

export default ProductOverview;